import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Swiftdezireonrentinpuneforcorporate() {



  const cardData =
  {
    keyword: ' Swift Dzire on Rent in Pune for Corporate',
    heading: 'Pune Corporate Cars India Private Limited: Swift Dzire on Rent in Pune for Corporate',
    headingDescription: 'Pune Corporate Cars India Private Limited offers Swift Dzire on rent in Pune for corporate travel, providing a comfortable, economical, and dependable transportation solution for employees, business visitors, and executives. The Swift Dzire is ideal for daily office commute, airport transfers, client meetings, and local business travel, delivering excellent mileage and a smooth travel experience. With trained chauffeurs, flexible rental plans, and well-maintained vehicles, we ensure punctual, safe, and hassle-free mobility for corporate clients. Pune Corporate Cars India Private Limited delivers a reliable and cost-effective travel experience with Swift Dzire rentals across Pune.',

    top: 'Top Places to Visit in Pune with Pune Corporate Car',

 "topPlaces": [
    {
      "title": "Hinjewadi Rajiv Gandhi Infotech Park",
      "description": "Hinjewadi Phase 1, 2 and 3 together form Pune’s largest corporate ecosystem, home to global IT companies, MNCs, tech parks, and business hubs. With campuses of Infosys, Wipro, Cognizant, TCS and more, it is Pune’s primary employment corridor. The area has wide roads, 24×7 transport demand, cafes, business hotels, and constant corporate mobility needs — making it one of the busiest routes served by Pune Corporate Cars."
    },
    {
      "title": "Magarpatta Cybercity",
      "description": "Magarpatta Cybercity is a self-sustained corporate township combining IT parks, residential spaces, restaurants, and premium office buildings. Known for its clean, green, and secure environment, it hosts major IT giants like Accenture, Infosys, Capgemini and Barclays. Corporate travel requirements, employee drop services, and daily office commutes make it a major business hub in Pune."
    },
    {
      "title": "Kharadi EON IT Park",
      "description": "EON IT Park is Pune’s fastest-growing commercial destination, filled with high-rise IT towers, premium offices, and multinational companies. Its four major clusters (A, B, C, D) attract thousands of daily employees. With tech companies, co-working spaces, and international business centers, Kharadi is a top route for corporate pick-drop and airport transfers."
    },
    {
      "title": "Viman Nagar Business District",
      "description": "Viman Nagar is a premium corporate and lifestyle hub near Pune Airport, known for its modern business centers, coworking spaces, hotels, and commercial complexes. Major malls, restaurants, and connectivity to Kharadi, Koregaon Park, and Yerwada make it a preferred zone for corporate travel, meetings, and executive cab services."
    },
    {
      "title": "Baner–Balewadi Corporate Hub",
      "description": "Baner and Balewadi have transformed into Pune’s new-age commercial cluster with IT companies, startups, co-working hubs, and premium business towers. It offers a cosmopolitan corporate environment with cafés, boardrooms, and business hotels. The area’s proximity to Hinjewadi makes corporate cab requirements extremely high for daily office mobility."
    },
    {
      "title": "Chakan MIDC Industrial Area",
      "description": "Chakan MIDC is one of India’s biggest industrial and automobile manufacturing clusters, housing companies like Volkswagen, Mercedes-Benz, Bajaj, LG, and Mahindra. With 24×7 transport operations, staff shifts, and inter-plant travel, it is a prime location served by corporate cab services, staff shuttle operations, and industrial commute solutions."
    },
    {
      "title": "Talegaon MIDC",
      "description": "Talegaon MIDC is known for its global manufacturing units, auto plants, and logistics hubs. It hosts companies such as General Motors, L&T, JCB, and POSCO. The area witnesses heavy employee movement and frequent business visits from executives — making structured corporate mobility critical for smooth travel between Pune city and the MIDC."
    },
    {
      "title": "Yerwada Business Corridor",
      "description": "Yerwada is a major commercial zone with corporate towers, business parks, and high-end office spaces like ICC Tech Park and Commerzone. It is a preferred location for corporate meetings, finance companies, and consulting firms. Its close connectivity to the airport and EON makes it a frequent route for corporate cabs and executive travel."
    },
    {
      "title": "Koregaon Park Business & Lifestyle District",
      "description": "Koregaon Park blends premium business centers with high-end lifestyle spaces, cafés, and boutique offices. It attracts startups, creative agencies, international firms, and co-working workspaces. The area is ideal for board meetings, client visits, and VIP travel — heavily relying on professional chauffeur-driven cabs."
    },
    {
      "title": "Pimpri-Chinchwad Industrial Belt",
      "description": "PCMC is one of Pune’s strongest industrial belts, filled with auto, engineering, and manufacturing companies. Areas like Pimpri, Chinchwad, Bhosari, and Nigdi host major factories and R&D centers. With shift-based employee travel and factory visits, corporate cab services remain essential for day-to-day operations."
    }
  ],


"services": [
{
"name": "Dzire Corporate Cab Pune",
"description": "Dzire Corporate Cab Pune provides reliable and professional sedan-based transportation for corporate employees and executives. The service ensures comfortable seating, GPS-enabled vehicles, trained drivers, and punctual pickups for office commutes, client visits, and business meetings across Pune."
},
{
"name": "Dzire Employee Pickup Drop Pune",
"description": "Dzire Employee Pickup Drop Pune offers structured and safe pickup and drop services for office staff and corporate employees using Dzire sedans. The service includes optimized routes, trained drivers, GPS tracking, and multi-shift support, ensuring efficient and comfortable commuting for employees."
},
{
"name": "Dzire Office Commute Pune",
"description": "Dzire Office Commute Pune delivers dependable sedan-based transport solutions for daily office commuting. The service emphasizes timely pickups, professional drivers, well-maintained vehicles, and comfort, making it ideal for IT parks, corporate offices, and business hubs in Pune."
},
{
"name": "Dzire Business Taxi Pune",
"description": "Dzire Business Taxi Pune provides premium sedan taxis for corporate travel, executive commutes, and business trips. With trained chauffeurs, GPS-enabled vehicles, and professional service, the service ensures safe, comfortable, and punctual transportation for corporate staff and clients."
},
{
"name": "Best Dzire Rental Pune",
"description": "Best Dzire Rental Pune offers top-quality Dzire sedans for corporate employee transport, office commuting, and executive travel. The service guarantees well-maintained vehicles, professional drivers, structured routes, GPS tracking, and reliable scheduling for smooth daily transportation."
},
{
"name": "Affordable Dzire Hire Pune",
"description": "Affordable Dzire Hire Pune provides cost-effective sedan rental services for corporate employees, office staff, and business travel. The service ensures safe, comfortable, and punctual rides with trained drivers, GPS tracking, and structured routes at competitive rates."
},
{
"name": "Dzire Outstation Cab Pune",
"description": "Dzire Outstation Cab Pune delivers safe and comfortable long-distance travel for corporate trips, client visits, and intercity commuting. The service features GPS-enabled sedans, trained drivers, optimized routes, and well-maintained vehicles to ensure a hassle-free outstation journey."
},
{
"name": "Dzire Airport Transfer Pune",
"description": "Dzire Airport Transfer Pune provides reliable and punctual airport transportation using Dzire sedans. The service includes trained drivers, luggage assistance, GPS tracking, and comfortable seating, ensuring a stress-free and professional airport commute for corporate staff and VIP clients."
},
{
"name": "Dzire Monthly Cab Hire Pune",
"description": "Dzire Monthly Cab Hire Pune offers long-term sedan rental solutions for corporate employees and office staff. The service includes fixed monthly plans, structured commuting schedules, trained chauffeurs, and GPS-monitored vehicles to provide consistent, safe, and comfortable transport."
},
{
"name": "Dzire Fleet Provider Pune",
"description": "Dzire Fleet Provider Pune delivers a fully managed fleet of Dzire sedans for corporate transportation. The service includes vehicle maintenance, driver management, GPS tracking, and route optimization, ensuring seamless, safe, and efficient daily commuting for businesses and organizations."
},
{
"name": "Sedan Dzire Corporate Rental Pune",
"description": "Sedan Dzire Corporate Rental Pune specializes in providing Dzire sedans for corporate employee transport, office commuting, and business travel. The service ensures punctual pickups, trained drivers, GPS-enabled vehicles, and comfortable seating for executives and staff."
},
{
"name": "Staff Commute Dzire Pune",
"description": "Staff Commute Dzire Pune offers dependable Dzire-based transport solutions for office and industrial staff. The service includes multi-shift support, structured routes, trained drivers, and GPS monitoring to ensure safe and efficient daily commuting for employees."
},
{
"name": "Company Dzire Car Pune",
"description": "Company Dzire Car Pune provides dedicated Dzire sedans for corporate employees, client visits, and business travel. The service focuses on safety, punctuality, GPS-enabled vehicles, professional drivers, and structured commuting schedules for seamless corporate transport."
},
{
"name": "Employee Shuttle Dzire Pune",
"description": "Employee Shuttle Dzire Pune delivers organized shuttle services for corporate staff using Dzire sedans. The service emphasizes optimized routes, punctual pickups, trained chauffeurs, and comfortable seating, ensuring smooth and reliable employee transportation across Pune."
},
{
"name": "Dzire Chauffeur Cars Pune",
"description": "Dzire Chauffeur Cars Pune provides professionally driven Dzire sedans for corporate executives, VIP clients, and staff. The service prioritizes comfort, safety, and punctuality, offering a premium commuting experience for office, business, and outstation travel."
}
],

"tableData": [
["Dzire Corporate Cab Pune", "Dzire Employee Pickup Drop Pune"],
["Dzire Office Commute Pune", "Dzire Business Taxi Pune"],
["Best Dzire Rental Pune", "Affordable Dzire Hire Pune"],
["Dzire Outstation Cab Pune", "Dzire Airport Transfer Pune"],
["Dzire Monthly Cab Hire Pune", "Dzire Fleet Provider Pune"],
["Sedan Dzire Corporate Rental Pune", "Staff Commute Dzire Pune"],
["Company Dzire Car Pune", "Employee Shuttle Dzire Pune"],
["Dzire Chauffeur Cars Pune", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Swift Dzire on Rent in Pune for Corporate",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited offers Swift Dzire rentals for corporate clients in Pune, providing reliable and comfortable transportation for business travel."
  },
  {
    "WhyChooseheading": "Comfortable & Efficient Swift Dzire",
    "WhyChoosedescription": "Our Swift Dzire vehicles are well-maintained, fuel-efficient, and designed for comfortable employee commuting and executive travel."
  },
  {
    "WhyChooseheading": "Ideal for Corporate Travel & Meetings",
    "WhyChoosedescription": "Whether for office commutes, business meetings, or client visits, Swift Dzire ensures convenient and stress-free travel."
  },
  {
    "WhyChooseheading": "Professional Chauffeur Service",
    "WhyChoosedescription": "All rentals come with trained, punctual, and courteous drivers, ensuring safe and disciplined travel for corporate clients."
  },
  {
    "WhyChooseheading": "Punctual & Hassle-Free Service",
    "WhyChoosedescription": "We prioritize timely pickups and drops, providing seamless and dependable corporate transportation."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "We offer hourly, daily, and long-term rental packages, allowing businesses to choose plans suited to their corporate travel needs."
  },
  {
    "WhyChooseheading": "Safe & Sanitized Vehicles",
    "WhyChoosedescription": "All Swift Dzire cars are regularly sanitized, serviced, and equipped with modern safety features for secure corporate commuting."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate travel is managed smoothly through our easy booking process and reliable coordination for employees and executives."
  }
]






























  }

const faqData = [
  {
    question: 'Do you provide Swift Dzire on rent for corporate clients in Pune?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers Swift Dzire rentals for corporate travel, employee transportation, and executive transfers in Pune.',
  },
  {
    question: 'Why choose Swift Dzire for corporate travel?',
    answer: 'Swift Dzire is comfortable, fuel-efficient, and ideal for daily employee commutes or executive travel within the city.',
  },
  {
    question: 'How can companies book Swift Dzire for corporate use?',
    answer: 'Bookings can be made through our website, mobile app, or by contacting our 24×7 corporate support team.',
  },
  {
    question: 'Can multiple Swift Dzire cars be booked for large corporate teams?',
    answer: 'Yes, Pune Corporate Cars India Private Limited can provide multiple Swift Dzire vehicles to accommodate large groups for corporate travel.',
  },
  {
    question: 'Are chauffeurs provided with Swift Dzire rentals?',
    answer: 'Absolutely. All Swift Dzire bookings come with trained and professional chauffeurs for a safe and comfortable commute.',
  },
  {
    question: 'Do you offer flexible rental packages for Swift Dzire?',
    answer: 'Yes, we provide hourly, half-day, full-day, and monthly rental options to meet corporate requirements.',
  },
  {
    question: 'Can Swift Dzire be hired for VIP corporate clients?',
    answer: 'Yes, Swift Dzire is suitable for executive and VIP transportation, ensuring comfort and reliability.',
  },
  {
    question: 'What safety measures are followed for Swift Dzire corporate rentals?',
    answer: 'All vehicles are GPS-enabled, sanitized regularly, and driven by verified and experienced chauffeurs.',
  },
  {
    question: 'What payment options are available for Swift Dzire corporate rentals?',
    answer: 'We accept UPI, credit/debit cards, bank transfers, digital wallets, and provide corporate invoicing for businesses.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Pratik Jadhav',
    feedback: 'Swift Dzire rentals from Pune Corporate Cars India Private Limited are highly reliable. Comfortable rides and professional drivers.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Vaishnavi Deshmukh',
    feedback: 'Excellent corporate service for Swift Dzire cars. Punctual, safe, and hassle-free commuting for our employees.',
    rating: 5,
  },
];

























































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Swift Dzire on Rent in Pune for Corporate",
  "image": "https://www.punecorporatecars.com/assets/images/swift-dzire-corporate-pune.jpg", // replace with actual image URL
  "description": "Pune Corporate Cars India Private Limited offers Swift Dzire on rent for corporate clients in Pune, including employee pickup and drop, office commute, business travel, outstation trips, and airport transfers. Ideal for IT employees, corporate fleets, and monthly corporate cab requirements with comfort and reliability.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",  // update if needed
    "ratingCount": "5600", // update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1500", // starting price, adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/swift-dzire-rent-corporate-pune"
  }
};






  return (
    <div>

<Helmet>
  <title>Swift Dzire on Rent in Pune for Corporate | Employee & Business Sedan Hire | Pune Corporate Cars India Private Limited</title>

  <meta
    name="description"
    content="Pune Corporate Cars India Private Limited offers Swift Dzire on rent for corporate clients in Pune, including employee pickup and drop, office commute, business travel, outstation trips, and airport transfers. Ideal for IT employees, corporate fleets, and monthly corporate cab requirements with comfort and reliability."
  />

  <meta
    name="keywords"
    content="Dzire Corporate Cab Pune, Dzire Employee Pickup Drop Pune, Dzire Office Commute Pune, Dzire Business Taxi Pune, Best Dzire Rental Pune, Affordable Dzire Hire Pune, Dzire Outstation Cab Pune, Dzire Airport Transfer Pune, Dzire Monthly Cab Hire Pune, Dzire Fleet Provider Pune, Sedan Dzire Corporate Rental Pune, Staff Commute Dzire Pune, Company Dzire Car Pune, Employee Shuttle Dzire Pune, Dzire Chauffeur Cars Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/40.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Swiftdezireonrentinpuneforcorporate;